<!--
 * @Description: 申请商户已提交成功组件
 * @Author: sunhuihong
 * @Date: 2022-10-12 08:43:52
 * @LastEditTime: 2022-10-12 18:01:26
-->
<template>
  <el-drawer title="申请收付通商户" :before-close="handleClose" :visible.sync="visible" direction="rtl" 
      size="1000px" ref="drawer" withHeader :wrapperClosable="wrapperClosable">
    <div class="apply-sucess" >
      <img style="width: 100px; height: 125px;" src="@/assets/common/icon-common-review-sucess.png" alt="">
      <div class="apply-sucess-title">恭喜你！申请商户已提交成功</div>
      <div class="apply-sucess-des">
        <span>您的申请已提交成功，请耐心等待1-2个工作日,可在</span>
        <span style="cursor: pointer; color: #3A7FF3;"  @click="handleMchReview">审核管理-商户审核</span>
        <span>模块查看审核进度哦！</span>
      </div>
      <div style="margin-top: 30px;">
        <el-button style="margin-right: 30px; width: 98px; text-align: center;" @click="handleClose">返 回</el-button>
        <el-button  type="primary" @click="handleDetails">查看详情</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'MchSubmitSucess',
  props: ["visible", "currentSuccessMchInstId"],
  data() {
    return {
      wrapperClosable: false,
    }
  },
  
  methods:{
    //返回，关闭当前抽屉操作
    handleClose() {
      this.$emit('close-drawer', false);
    },

    //查看收付通商户详情
    handleDetails() {
      this.$emit('close-drawer', true);
    },

    //调转商户审核菜单
    handleMchReview() {
      this.$router.push({name: 'mchreview', params: {institutionId: this.currentSuccessMchInstId}});
    }
  },
}
</script>

<style scoped>
.apply-sucess {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 120px;
}

.apply-sucess-des {
  width:380px;
  text-align:left;
  font-size: 14px;
  line-height: 20px;
  color: #666666;
}

.apply-sucess-title {
  font-size: 15px;
  font-weight: 400;
  color: #333333;
  line-height: 21px;
  margin: 15px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/mchmng/components/MchSubmitSucess.vue